import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { CuttingStrapTypeService } from 'services/cutting-strap-type-service';
import { ErrorService } from 'services/error-service';

@autoinject
export class CuttingStrapTypeList {
  private tableData: Array<Models.CuttingStrapType>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private cuttingStrapTypeService: CuttingStrapTypeService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('cuttingStrapTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.cuttingStrapTypeService
      .getAll()
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('cutting-strap-type-detail', { Id: id });
  }
}
